var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAiStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1052_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99739 5.24622C6.41161 5.24622 6.74739 5.582 6.74739 5.99622C6.74739 7.79206 8.20321 9.24788 9.99906 9.24788C10.4133 9.24788 10.7491 9.58367 10.7491 9.99788C10.7491 10.4121 10.4133 10.7479 9.99906 10.7479C8.20321 10.7479 6.74739 12.2037 6.74739 13.9995C6.74739 14.4138 6.41161 14.7495 5.99739 14.7495C5.58318 14.7495 5.24739 14.4138 5.24739 13.9995C5.24739 12.2037 3.79157 10.7479 1.99573 10.7479C1.58151 10.7479 1.24573 10.4121 1.24573 9.99788C1.24573 9.58367 1.58151 9.24788 1.99573 9.24788C3.79157 9.24788 5.24739 7.79206 5.24739 5.99622C5.24739 5.582 5.58318 5.24622 5.99739 5.24622ZM5.99739 8.55952C5.62721 9.13624 5.13575 9.62769 4.55904 9.99788C5.13575 10.3681 5.62721 10.8595 5.99739 11.4362C6.36758 10.8595 6.85904 10.3681 7.43575 9.99788C6.85904 9.62769 6.36758 9.13624 5.99739 8.55952Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4999 7.24988C16.9141 7.24988 17.2499 7.58566 17.2499 7.99988C17.2499 10.6232 19.3765 12.7499 21.9999 12.7499C22.4141 12.7499 22.7499 13.0857 22.7499 13.4999C22.7499 13.9141 22.4141 14.2499 21.9999 14.2499C19.3765 14.2499 17.2499 16.3765 17.2499 18.9999C17.2499 19.4141 16.9141 19.7499 16.4999 19.7499C16.0857 19.7499 15.7499 19.4141 15.7499 18.9999C15.7499 16.3765 13.6232 14.2499 10.9999 14.2499C10.5857 14.2499 10.2499 13.9141 10.2499 13.4999C10.2499 13.0857 10.5857 12.7499 10.9999 12.7499C13.6232 12.7499 15.7499 10.6232 15.7499 7.99988C15.7499 7.58566 16.0857 7.24988 16.4999 7.24988ZM16.4999 10.971C15.9212 12.04 15.04 12.9212 13.971 13.4999C15.04 14.0786 15.9212 14.9598 16.4999 16.0288C17.0786 14.9598 17.9598 14.0786 19.0288 13.4999C17.9598 12.9212 17.0786 12.04 16.4999 10.971Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 18.2499C16.9143 18.2499 17.2501 18.5857 17.2501 18.9999V20.0003C17.2501 20.4145 16.9143 20.7503 16.5001 20.7503C16.0859 20.7503 15.7501 20.4145 15.7501 20.0003V18.9999C15.7501 18.5857 16.0859 18.2499 16.5001 18.2499Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 6.24988C16.9143 6.24988 17.2501 6.58566 17.2501 6.99988V8.00029C17.2501 8.41451 16.9143 8.75029 16.5001 8.75029C16.0859 8.75029 15.7501 8.41451 15.7501 8.00029V6.99988C15.7501 6.58566 16.0859 6.24988 16.5001 6.24988Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49988 17.2499C9.91409 17.2499 10.2499 17.5857 10.2499 17.9999V19.9999C10.2499 20.4141 9.91409 20.7499 9.49988 20.7499C9.08566 20.7499 8.74988 20.4141 8.74988 19.9999V17.9999C8.74988 17.5857 9.08566 17.2499 9.49988 17.2499Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74988 18.9999C7.74988 18.5857 8.08566 18.2499 8.49988 18.2499H10.4999C10.9141 18.2499 11.2499 18.5857 11.2499 18.9999C11.2499 19.4141 10.9141 19.7499 10.4999 19.7499H8.49988C8.08566 19.7499 7.74988 19.4141 7.74988 18.9999Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 3.24988C12.9141 3.24988 13.2499 3.58566 13.2499 3.99988V5.99988C13.2499 6.41409 12.9141 6.74988 12.4999 6.74988C12.0857 6.74988 11.7499 6.41409 11.7499 5.99988V3.99988C11.7499 3.58566 12.0857 3.24988 12.4999 3.24988Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7499 4.99988C10.7499 4.58566 11.0857 4.24988 11.4999 4.24988H13.4999C13.9141 4.24988 14.2499 4.58566 14.2499 4.99988C14.2499 5.41409 13.9141 5.74988 13.4999 5.74988H11.4999C11.0857 5.74988 10.7499 5.41409 10.7499 4.99988Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99744 13.2496C6.41165 13.2496 6.74744 13.5854 6.74744 13.9996V15.0001C6.74744 15.4143 6.41165 15.7501 5.99744 15.7501C5.58322 15.7501 5.24744 15.4143 5.24744 15.0001V13.9996C5.24744 13.5854 5.58322 13.2496 5.99744 13.2496Z",
    className: "icon-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99744 4.24573C6.41165 4.24573 6.74744 4.58151 6.74744 4.99573V5.99614C6.74744 6.41036 6.41165 6.74614 5.99744 6.74614C5.58322 6.74614 5.24744 6.41036 5.24744 5.99614V4.99573C5.24744 4.58151 5.58322 4.24573 5.99744 4.24573Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1052_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAiStars);
export default __webpack_public_path__ + "static/media/icon-ai-stars.c4bd60d2c8a22b855fc39b365b84f299.svg";
export { ForwardRef as ReactComponent };